module.exports = __webpack_public_path__ + "img/10_uk.5f1977ec.svg";